import React from 'react'
import _ from 'lodash'

const Rating = (props) => {
  let starts = Array(5);
  _.fill(starts, 0);
  const full = Math.floor(props.rating);
  _.fill(starts, 1, 0, full);
  if(props.rating > full)
    _.fill(starts, 0.5, full, full + 1);

  return(
    <div className="rating">
      {starts.map((r, idx) => {
        if(r === 1)
          return <i key={idx} className="rating-full"/>;
        if(r > 0 && r < 1)
          return <i key={idx} className="rating-half"/>;
        else
          return <i key={idx} className="rating-none"/>;
      })}
    </div>
  )
};

Rating.defaultProps = {
  rating: 0
};

export default Rating;